module.exports = __webpack_public_path__ + "static/media/curriculum_theme_robot.cef14796.svg";